import { render, staticRenderFns } from "./UnitGroupCategory.vue?vue&type=template&id=27c5cea1&"
import script from "./UnitGroupCategory.vue?vue&type=script&lang=js&"
export * from "./UnitGroupCategory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports